import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6Ldau3sqAAAAAKAPzvz5Nk6gf5qgfRrxkl3MdoE3",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});